import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link, useLocation } from "react-router-dom";

const Header: React.FC = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); // ✅ NEW
  const headerRef = useRef<HTMLElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // close menus when route changes
  useEffect(() => {
    setMenuOpen(false);
    setShowDropdown(false);
  }, [location.pathname]);

  const lightPages = ["/about", "/planning", "/interior", "/exterior"];
  const isLightPage = lightPages.includes(location.pathname);
  const isDarkHeader = scrolled || !isLightPage;

  return (
    <header ref={headerRef} className={`site-header ${scrolled ? "scrolled" : ""}`}>
      {/* LEFT: Logo */}
      <Link
        to="/"
        className={`logo-container ${scrolled ? "scrolled" : isLightPage ? "light" : "dark"}`}
        onClick={() => setMenuOpen(false)}
        aria-label="Nextudio Architects"
      >
        <img
          className={`logo-image ${isDarkHeader ? "logo-image--invert" : ""}`}
          src="/images/Nextudiolg.png"
          alt="Nextudio Architects"
          decoding="async"
        />
      </Link>



      {/* RIGHT: nav + share + hamburger */}
      <div className="header-right">
        {/* hamburger (mobile only, styled in CSS) */}
        <button
          className={`menu-toggle ${menuOpen ? "is-open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(v => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        {/* nav – note the classes 'site-nav' and 'open' */}
        <nav className={`site-nav ${isLightPage ? "light-nav" : "dark-nav"} ${menuOpen ? "open" : ""}`}>
          <ul style={navListStyle}>
            <li>
              <Link
                to="/"
                className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className={`nav-link ${location.pathname === "/projects" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Our Projects
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>

        {/* share button (hidden on phones via CSS) */}
        <div
          title="Follow Us"
          className="share-button"
          style={buttonBox}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <i className="fas fa-link" />
        </div>

{showDropdown && (
  <div className="social-dropdown">
    <a href="https://www.behance.net/nextudiobeirut" target="_blank" rel="noopener noreferrer" className="social-icon">
      <img src="/images/social/behance.svg" alt="Behance" />
    </a>
    <a href="https://www.facebook.com/share/1ZsvmkC3Xc/" target="_blank" rel="noopener noreferrer" className="social-icon">
      <img src="/images/social/facebook.svg" alt="Facebook" />
    </a>
    <a href="https://www.instagram.com/nextudio.co?igsh=MTVkbDIwN3kxazRkbA==" target="_blank" rel="noopener noreferrer" className="social-icon">
      <img src="/images/social/insta.svg" alt="Instagram" />
    </a>
    <a href="https://www.linkedin.com/company/nextudio-architects/" target="_blank" rel="noopener noreferrer" className="social-icon">
      <img src="/images/social/linkedin.svg" alt="LinkedIn" />
    </a>
  </div>
)}


      </div>
    </header>
  );
};

const navListStyle: React.CSSProperties = {
  listStyle: "none",
  display: "flex",
  gap: "var(--nav-gap, 2rem)",
  margin: 0,
  padding: 0,
  fontSize: "0.8rem",
  letterSpacing: "1px",
  textTransform: "uppercase",
};

const buttonBox: React.CSSProperties = {
  border: "1px solid white",
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.2rem",
  cursor: "pointer",
  color: "white",
};

export default Header;

